import { render, staticRenderFns } from "./RiskSurveyManagement.vue?vue&type=template&id=b5554ac2&"
import script from "./RiskSurveyManagement.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyManagement.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports